document.addEventListener('DOMContentLoaded', function () {
  // Media Gallery Switcher (Images & Videos)
  const thumbnails = document.querySelectorAll('[data-media-thumbnail]');
  const mainMediaContainer = document.querySelector('[data-main-media-container]');

  if (thumbnails.length && mainMediaContainer) {
    thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', function () {
        thumbnails.forEach((t) => t.classList.remove('border-ember'));
        this.classList.add('border-ember');

        const mediaType = this.dataset.mediaType;
        const mediaSrc = this.dataset.mediaSrc;
        const mediaAlt = this.dataset.mediaAlt || '';

        if (mediaType === 'video') {
          mainMediaContainer.innerHTML = `
            <video src="${mediaSrc}" controls autoplay loop muted class="w-full h-full object-cover">
              Seu navegador não suporta vídeos.
            </video>
          `;
        } else {
          mainMediaContainer.innerHTML = `
            <img src="${mediaSrc}" alt="${mediaAlt}" class="w-full h-full object-cover transition-opacity duration-500" />
            <div class="absolute inset-0 shadow-[inset_0_0_120px_rgba(0,0,0,0.55)] pointer-events-none"></div>
          `;
        }
      });
    });
  }

  // Variant selector change handler
  const variantSelect = document.querySelector('[data-variant-select]');
  const priceDisplay = document.querySelector('[data-product-price]');
  const inventoryDisplay = document.querySelector('[data-inventory-display]');
  const addToCartBtn = document.querySelector('[data-add-to-cart]');
  const consultaLink = document.querySelector('[data-consulta-whatsapp]');

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const selectedOption = this.options[this.selectedIndex];
      const price = selectedOption.dataset.price;
      const available = selectedOption.dataset.available === 'true';

      if (priceDisplay && price) {
        priceDisplay.textContent = price;
      }

      if (inventoryDisplay) {
        inventoryDisplay.innerHTML = `<span class="text-ember font-medium">Produto sob consulta</span>`;
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = !available;
        addToCartBtn.style.display = available ? '' : 'none';
      }

      if (consultaLink) {
        const variantTitle = selectedOption.dataset.title;
        let msg = `Olá! Vi esse produto no site SG e gostaria de mais informações sobre: ${consultaLink.dataset.productTitle}`;
        if (variantTitle && variantTitle !== 'Default Title') {
          msg += ` (${variantTitle})`;
        }
        msg += ` - ${consultaLink.dataset.productUrl}`;
        consultaLink.href = `https://wa.me/5554996876025?text=${encodeURIComponent(msg)}`;
        consultaLink.style.display = available ? 'none' : '';
      }
    });
  }

  // Handle direct checkout action: Add to Shopify Cart via AJAX & Submit Checkout
  window.handleDirectCheckout = function(variantId, btnElement) {
    if (!variantId) return;

    if (btnElement) {
      btnElement.disabled = true;
      btnElement.textContent = 'PROCESSANDO...';
    }

    const payload = {
      items: [{
        id: variantId,
        quantity: 1
      }]
    };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(() => {
      // Submit form directly to /cart with name=checkout to trigger Yampi App sync
      const checkoutForm = document.createElement('form');
      checkoutForm.method = 'POST';
      checkoutForm.action = '/cart';

      const checkoutInput = document.createElement('input');
      checkoutInput.type = 'hidden';
      checkoutInput.name = 'checkout';
      checkoutInput.value = 'Checkout';
      checkoutForm.appendChild(checkoutInput);

      document.body.appendChild(checkoutForm);
      checkoutForm.submit();
    })
    .catch(err => {
      console.error('Erro no checkout direto:', err);
      window.location.href = '/cart';
    });
  };

  // Add to Cart AJAX handler
  const addToCartForm = document.getElementById('AddToCartForm');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      if (e.submitter && e.submitter.name === 'add') {
        e.preventDefault();
        const submitBtn = e.submitter;
        const originalText = submitBtn.textContent;
        submitBtn.disabled = true;
        submitBtn.textContent = 'ADICIONANDO...';

        const formData = new FormData(this);
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(res => res.json())
        .then(() => {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
          if (typeof window.refreshCartDrawer === 'function') {
            window.refreshCartDrawer();
          }
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          } else {
            window.location.href = '/cart';
          }
        })
        .catch(() => {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
          window.location.href = '/cart';
        });
      }
    });
  }

  // Product recommendations (related / complementary) — swap via Section Rendering API
  document.querySelectorAll('[data-recommendations]:not([data-loaded])').forEach(function (el) {
    const url = el.getAttribute('data-url');
    if (!url) return;
    el.setAttribute('data-loaded', 'true');

    fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('recommendations unavailable');
        return res.text();
      })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-recommendations]');
        if (!fresh) { el.remove(); return; }
        const grid = fresh.querySelector('[data-recommendations-grid]');
        if (!grid || grid.children.length === 0) { el.remove(); return; }
        fresh.setAttribute('data-loaded', 'true');
        el.replaceWith(fresh);
      })
      .catch(function () {});
  });
});
